import { worker } from "./browser";

export const mock = worker.use;
